import Cookies from "js-cookie";

class PromoService {
  baseUrl = `${import.meta.env.VITE_API_BASE_URL}promos/`;

  private get csrf() {
    return Cookies.get("csrftoken") ?? "";
  }

  getPromoCodesAsync = async () => {
    const res = await fetch(this.baseUrl, {
      headers: { "Content-Type": "application/json" },
      credentials: "include",
    });
    return res.json();
  };

  createPromoCodeAsync = async (data: any) => {
    const res = await fetch(this.baseUrl, {
      method: "POST",
      body: JSON.stringify(data),
      headers: { "Content-Type": "application/json", "X-CSRFToken": this.csrf },
      credentials: "include",
    });
    return res.json();
  };

  updatePromoCodeAsync = async (id: string, data: any) => {
    const res = await fetch(`${this.baseUrl}${id}/`, {
      method: "PUT",
      body: JSON.stringify(data),
      headers: { "Content-Type": "application/json", "X-CSRFToken": this.csrf },
      credentials: "include",
    });
    return res.json();
  };

  deletePromoCodeAsync = async (id: string) => {
    return fetch(`${this.baseUrl}${id}/`, {
      method: "DELETE",
      headers: { "X-CSRFToken": this.csrf },
      credentials: "include",
    });
  };

  getUpcomingShowsAsync = async () => {
    const res = await fetch(`${this.baseUrl}upcoming-shows/`, {
      headers: { "Content-Type": "application/json" },
      credentials: "include",
    });
    return res.json();
  };

  validatePromoCodeAsync = async (code: string) => {
    const res = await fetch(`${this.baseUrl}validate/`, {
      method: "POST",
      body: JSON.stringify({ code }),
      headers: { "Content-Type": "application/json", "X-CSRFToken": this.csrf },
      credentials: "include",
    });
    return res.json();
  };
}

export default new PromoService();
